import { Utils } from '@klickdata/core/util';
import { switchMap, takeUntil } from 'rxjs/operators';
import { UserService } from '@klickdata/core/user';
import { Widget, WidgetData } from '@klickdata/core/widget';
import { Component, OnInit, ChangeDetectionStrategy, EventEmitter, Input, Output, OnDestroy } from '@angular/core';
import { SideNaveActionsTypes, SideNaveData } from '@klickdata/core/mobile';
import { SideNaveResponseData } from '@klickdata/core/mobile/src/mobile.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AuthService } from '@klickdata/core/auth';
import { Subject } from 'rxjs';
import { MessageSavedComponent, MessageService } from '@klickdata/core/message';

@Component({
    selector: 'app-menu-side-dashboard-column-settings',
    templateUrl: './menu-side-dashboard-column-settings.component.html',
    styleUrls: ['./menu-side-dashboard-column-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuSideDashboardColumnSettingsComponent implements OnDestroy {
    @Input() public navData: SideNaveData;
    @Output() onClose: EventEmitter<SideNaveResponseData> = new EventEmitter();
    public kdColorsSet: string[];
    private destroy = new Subject<boolean>();
    SideNaveActionsTypes = SideNaveActionsTypes;
    // public widgets = [
    //     {
    //         id: 1,
    //         name: $localize`Latest News`,
    //         visible: true,
    //         order: 1,
    //         color: '#3e5365',
    //         icon: 'newspaper',
    //         checked: true,
    //         value: 'news',
    //     },
    //     // {
    //     //     id: 2,
    //     //     name: $localize`Calendar`,
    //     //     visible: true,
    //     //     order: 2,
    //     //     color: '#3e5365',
    //     //     icon: 'calendar',
    //     //     checked: true,
    //     //     value: 'calendar',
    //     // },
    //     {
    //         id: 3,
    //         name: $localize`Messages`,
    //         visible: true,
    //         order: 3,
    //         color: '#3e5365',
    //         icon: 'message',
    //         checked: true,
    //         value: 'messages',
    //     },
    // ];
    public widgets;
    constructor(protected userService: UserService, protected auth: AuthService, protected message: MessageService) {
        this.kdColorsSet = Utils.getKDColors();
    }
    ngOnInit(): void {
        this.widgets = this.navData.data.widgets;
    }
    drop(event: CdkDragDrop<any[]>) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    }
    public onSubmit(widgets: any[]) {
        this.onClose.emit({
            action: SideNaveActionsTypes.POSITIVE,
            data: {
                widgets: this.widgets.map((widget) => ({
                    id: widget.id,
                    visible: widget.checked,
                    value: widget.value,
                })),
                type: this.navData.data.type,
            },
        });
        return;
        this.auth
            .getUser()
            .pipe(
                switchMap((user) =>
                    this.userService.update(
                        this.navData.data.customerId
                            ? {
                                  id: user.id,
                                  widgets: widgets.map(
                                      (widget, index) =>
                                          <WidgetData>{
                                              id: widget.id,
                                              visible: widget.visible,
                                              order: index,
                                              color: widget.color,
                                          }
                                  ),
                                  customer_id: this.navData.data.customerId,
                              }
                            : {
                                  id: user.id,
                                  widgets: widgets.map(
                                      (widget, index) =>
                                          <WidgetData>{
                                              id: widget.id,
                                              visible: widget.visible,
                                              order: index,
                                              color: widget.color,
                                          }
                                  ),
                              }
                    )
                ),
                takeUntil(this.destroy)
            )
            .subscribe(() => {
                this.message.openMessage(MessageSavedComponent);
                this.onClose.emit({
                    action: SideNaveActionsTypes.POSITIVE,
                    data: { widgets: widgets, type: this.navData.data.type },
                });
            });
    }
    ngOnDestroy(): void {
        this.destroy.next(true);
        this.destroy.unsubscribe();
    }
}
